var map = {
	"./Andriod.svg": "axpL",
	"./arrow_left.svg": "hJvJ",
	"./checkbox_circle_nor.svg": "BrlC",
	"./checkbox_circle_sel.svg": "VEO+",
	"./copy.svg": "jZ9W",
	"./data_filled_nor.svg": "+53C",
	"./data_filled_sel.svg": "Nk/+",
	"./garbage.svg": "0UsO",
	"./home.svg": "jdp8",
	"./ic_apply_filled_nor.svg": "HgB+",
	"./ic_apply_filled_sel.svg": "4wb+",
	"./ic_message_filled_nor.svg": "hiaZ",
	"./ic_message_filled_sel.svg": "B6C9",
	"./ic_mine_filled_nor.svg": "0UEw",
	"./ic_mine_filled_sel.svg": "DLA1",
	"./ios.svg": "yB2T",
	"./mine_filled_nor.svg": "o7NS",
	"./mine_filled_sel.svg": "eDPS",
	"./mine_ic_distribution.svg": "1DrU",
	"./mine_ic_download.svg": "Tmly",
	"./mine_ic_service.svg": "EmCq",
	"./mini_arrow_down.svg": "JCO8",
	"./mini_arrow_right-cyan.svg": "PvF2",
	"./mini_arrow_right.svg": "T3Hl",
	"./mini_arrow_right_empty.svg": "Xymd",
	"./mini_arrow_right_white.svg": "2R+D",
	"./pay_wx.svg": "QDoJ",
	"./pay_zfb.svg": "4SZg",
	"./phone.svg": "j445",
	"./plusvip_img_p.svg": "7AKr",
	"./scan.svg": "vj0k",
	"./setting.svg": "2gSz",
	"./share.svg": "NGe3",
	"./shop_filled_nor.svg": "j6JC",
	"./shop_filled_sel.svg": "BguD",
	"./success.svg": "AQ5E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xm7Z";


//////////////////
// WEBPACK FOOTER
// ./src/icons nonrecursive \.svg$
// module id = Xm7Z
// module chunks = 22